import React, { Component } from 'react';
import map from 'lodash/map';
// import reject from 'lodash/reject';
import moment from 'moment-timezone';
import { Modal, Button, DatePicker } from 'antd';
import cross_icon from '../../../../Assets/images/cross_icon.svg';
import green_tick from '../../../../Assets/images/useraccount/green_tick.png';
import Upload_Photo from '../../../../Assets/images/Upload_Photo.svg';
// import peeking_doodle from '../../../../Assets/images/useraccount/peeking_doodle.svg';
import doody_dog from '../../../../Assets/images/useraccount/doody_dog.png';
// const safetyInfo = [
//   {key: 'is_friendly', value: 'Yes, my dog is friendly.'},
//   {key: 'can_treat', value: 'Yes, you can give my dog a treat.'},
//   {key: 'can_clean_if_in_yard', value: 'Yes, you can clean with my dogs in the yard'},
//   {key: 'has_doggy_door', value: 'Yes, there a doggy door'},
//   {key: 'is_dogs_outside', value: 'Yes, Dogs are left outside when no one is home'},
// ];

const displaySafetyInfo = [
  {key: 'is_friendly', value: 'Friendly'},
  {key: 'can_clean_if_in_yard', value: 'Clean with dog in yard'},
  {key: 'can_treat', value: 'Treats Allowed'},
  {key: 'has_doggy_door', value: 'Doggy Door?'},
  {key: 'is_dogs_outside', value: 'Left outside when no one is home'},
]

class Dogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dog_info: {},
      dog_list: [],
      ServiceData: [],
      is_delete: false,
      loader: false,
      is_edit_info: false,
      is_dog_img: false,
      is_update: false,
      is_mobile: false,
      errors: {}
    }
  }

  componentDidMount = () => {
    // get dog list
    this.props.getPets();

    // Get All service address
    // this.props.getServiceOrder();
    this.setState({ loader: true });

    setTimeout(() => {
      window.scrollTo(0, 0);
      var self = this;
      setTimeout(() => {
        this.updateDimensions();
        window.addEventListener("resize", self.updateDimensions.bind(self));
      }, 500);
    }, 300);
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    // let { dog_info } = this.state;
    // Add Dog details
    if (Object.keys(props.addedDog.data).length > 0 && props.addedDog.data !== this.props.addedDog.data) {
      this.props.getPets();
      this.setState({
        is_edit_info: false,
        is_dog_img: false
      })
    }
    if (Object.keys(props.addedDog.errors).length > 0 && props.addedDog.errors !== this.props.addedDog.errors) {
      // display error messsage

    }


    // Get dog list from api
    if (Object.keys(props.DogList.data).length > 0 && props.DogList.data !== this.props.DogList.data) {
      this.setState({
        dog_list: props.DogList.data.results,
        dog_info: {}
      })
    }

    if (Object.keys(props.DogList.errors).length > 0 && props.DogList.errors !== this.props.DogList.errors) {
      // display error messsage
    }

    // Updated Dog details
    if (Object.keys(props.updatedDog.data).length > 0 && props.updatedDog.data !== this.props.updatedDog.data) {
      this.props.getPets();
      this.setState({
        is_edit_info: false,
        is_dog_img: false
      })
    }
    if (Object.keys(props.updatedDog.errors).length > 0 && props.updatedDog.errors !== this.props.updatedDog.errors) {
      // display error messsage
      this.setState({
        is_dog_img: false
      })
    }
    // Deleted Dog details
    if (Object.keys(props.deletedPets.data).length > 0 && props.deletedPets.data !== this.props.deletedPets.data) {
      this.props.getPets();
    }
    // Service Order details
    if (Object.keys(props.serviceOrder.data).length > 0 && props.serviceOrder.data !== this.props.serviceOrder.data) {
      this.props.getPets();
     
      // if (props.serviceOrder.data.results.length < 3) {
      //   Object.assign(dog_info, { 'service_order_uuid': props.serviceOrder.data.results[0].uuid })

      // }
      this.setState({
        ServiceData: props.serviceOrder.data.results,
        // dog_info
      })
    }
    if (Object.keys(props.serviceOrder.errors).length > 0 && props.serviceOrder.errors !== this.props.serviceOrder.errors) {
      // display error messsage
    }

    var self = this;
    setTimeout(() => {
      self.setState({
        loader: false
      })
    }, 1000);

  }

  // render dog list
  renderDogList = () => {
    let { dog_list } = this.state;
    return map(dog_list && dog_list, (item, i) => {

      return (
        <div className="col-md-6 col-xl-4 col-lg-4" key={i}>
          <div className="service_card dog_info_card">
            <div className="body">

              <div className="dog_details">
                <div className={item.photo ? 'dog_img' : 'dog_img doody_dog'}>
                  {item.photo ? <img src={item.photo} alt="" /> : <img src={doody_dog} alt="" />}

                </div>
                <div className="dog_name">
                  <label>{item.name}</label>
                  <span>{item.breed || '---'}</span>
                  <span>{item.birthday || '---'}</span>
                </div>
              </div>

              <div className="safety_info ">
                <ul>
                  {map(displaySafetyInfo, (obj) => {
                    return (
                      <li key={obj.key}>
                        {item[obj.key] ?
                          <img src={green_tick} alt="" className="green_tick" /> :
                          <img src={cross_icon} alt="" className="green_tick" />
                        }

                        <label>{obj.value}</label>
                      </li>
                    )
                  })}
                  {/*<li>*/}
                  {/*  {item.is_friendly ?*/}
                  {/*    <img src={green_tick} alt="" className="green_tick" /> :*/}
                  {/*    <img src={cross_icon} alt="" className="green_tick" />*/}
                  {/*  }*/}

                  {/*  <label>Friendly</label>*/}
                  {/*</li>*/}
                  {/*<li>*/}
                  {/*  {item.can_clean_if_in_yard ?*/}
                  {/*    <img src={green_tick} alt="" className="green_tick" /> :*/}
                  {/*    <img src={cross_icon} alt="" className="green_tick" />*/}
                  {/*  }*/}
                  {/*  <label>Clean with dog in yard</label>*/}
                  {/*</li>*/}
                  {/*<li>*/}
                  {/*  {item.can_treat ?*/}
                  {/*    <img src={green_tick} alt="" className="green_tick" /> :*/}
                  {/*    <img src={cross_icon} alt="" className="green_tick" />*/}
                  {/*  }*/}
                  {/*  <label>Treats Allowed</label>*/}
                  {/*</li>*/}
                  {/*<li>*/}
                  {/*  {item.has_doggy_door ?*/}
                  {/*    <img src={green_tick} alt="" className="green_tick" /> :*/}
                  {/*    <img src={cross_icon} alt="" className="green_tick" />*/}
                  {/*  }*/}
                  {/*  <label>Doggy Door?</label>*/}
                  {/*</li>*/}
                </ul>

                <div className="dog_desc">
                  <label>Additional Information</label>
                  <p>{item.additional_info ? item.additional_info : '-'}</p>
                </div>

                <div className="dog_desc">
                  <label>About Dogs</label>
                  <p>{item.about_your_dogs ? item.about_your_dogs : '-'}</p>
                </div>

                <div className="dog_address">
                  <label>Service Addresses</label>
                  <span>{item.service_address}</span>
                </div>
              </div>
              <div className="dog_action">
                {/* <Popconfirm
                  title="Are you sure delete this dog?"
                  onConfirm={() => {
                    this.props.deletePets(item.uuid);
                    this.setState({ loader: true });
                    this.setState({
                      dog_list: reject(dog_list, function (el) { return el.uuid === item.uuid })
                    })
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <span>Delete</span>
                </Popconfirm>, */}
                <span onClick={() => {
                  this.setState({ is_edit_info: true, dog_info: {...item, birthday: item?.birthday ? moment(item?.birthday).format('MM/DD/YYYY') : null}, is_update: true });
                }}>Edit</span>
              </div>
            </div>
          </div>
        </div>
      )
    })

  }

  // dog name and breed change
  onDogTextChange = (e) => {
    let { dog_info } = this.state;
    let temp_dog_info = { ...dog_info }
    Object.assign(temp_dog_info, { [e.target.name]: e.target.value });
    this.setState({
      dog_info: temp_dog_info
    })

  }
  //update or ad fog dob
  onDogdateChange = (e) => {
    let { dog_info } = this.state;
    let temp_dog_info = { ...dog_info }
    Object.assign(temp_dog_info, { 'birthday': moment(e).format('MM/DD/YYYY') });
    this.setState({
      dog_info: temp_dog_info
    })
  }

  // on birthday change
  onBirthdayChange = (e) => {
    const {dog_info} = this.state;
    let temp_dog_info = {...dog_info}
    const value = e.target.value;
    let new_value = value
    if (value?.length === 2) {
      new_value = value + '/'
    } else if (value?.length === 5) {
      new_value = value + '/'
    }
    Object.assign(temp_dog_info, { 'birthday': new_value });
    this.setState({dog_info: temp_dog_info})
  }

  // on birthday key press event
  onBirthdayKeyPress = (e) => {
    let {dog_info} = this.state;
    let temp_dog_info = {...dog_info}
    const birthday = temp_dog_info?.birthday
    const value = e.key;
    if (value === "Backspace") {
      if (birthday.substr(birthday?.length - 1, 1) === '/') {
        e.preventDefault()
        Object.assign(temp_dog_info, {birthday: birthday.substr(0, birthday?.length - 1)});
        this.setState({dog_info: temp_dog_info})
      }
    }
  }

  // dog checklist change
  onDogCheckChange = (e) => {
    let { dog_info } = this.state;
    let temp_dog_info = { ...dog_info }
    Object.assign(temp_dog_info, { [e.target.name]: e.target.checked });
    this.setState({
      dog_info: temp_dog_info
    })
  }
  // Dog Profile pic upload
  onDogImagesChange = (e) => {
    let { dog_info } = this.state;
    let temp_dog_info = { ...dog_info }
    const reader = new FileReader();
    reader.onloadend = function () {
      Object.assign(temp_dog_info, { 'photo': reader.result });
    }
    reader.readAsDataURL(e.target.files[0]);

    setTimeout(() => {
      this.setState({ dog_info: temp_dog_info, is_dog_img: true })
    }, 100);
  }

  //Add and Update Dog info
  AddAndUpdateDog = (e) => {
    e.preventDefault();
    let { dog_info, is_dog_img, is_update, errors } = this.state;
    if (dog_info?.birthday && (!moment(dog_info?.birthday).isValid() || !(moment(dog_info?.birthday) <= moment().endOf('day'))) ) {
      Object.assign(errors, {'birthday': 'Invalid date'})
      this.setState({errors})
    } else {
      this.setState({errors: {}})
      if (dog_info.photo) {
        if (!is_dog_img) {
          delete dog_info.photo
        }
      } else {
        delete dog_info.photo
      }


      if (is_update) {
        this.setState({
          loader: true,
        })
        // Update dog API CALL
        delete dog_info.about_your_dogs;
        this.props.UpdatePets({...dog_info, birthday: dog_info.birthday ? moment(dog_info.birthday).format('YYYY-MM-DD') : null})
      } else {
        if (dog_info.name && dog_info.service_order_uuid) {
          this.setState({
            loader: true,
          })
          this.props.addPets({...dog_info, birthday: dog_info.birthday ? moment(dog_info.birthday).format('YYYY-MM-DD') : null})
        }

      }
    }
  }

  serviceAddressCheck = (e, item) => {
    let { dog_info } = this.state;
    let temp_dog_info = { ...dog_info }
    if (e.target.checked) {
      Object.assign(temp_dog_info, { 'service_order_uuid': item.uuid });
      this.setState({
        dog_info: temp_dog_info
      })
    }
  }
  // Calculate dimensions
  updateDimensions() {
    var self = this;
    if (window.innerWidth <= 500) {
      //true
      self.setState({
        is_mobile: true
      })

    }
    else {
      self.setState({
        is_mobile: false
      })
    }
  }
  //render dog service address
  renderServiceOrder = () => {
    let { ServiceData, dog_info } = this.state;
    return map(ServiceData && ServiceData, (item, i) => {
      return (
        <div className="checkbox_wrapper mb-2 green-check" key={i}>
          <input type="checkbox" id={i}
            checked={dog_info.service_order_uuid === item.uuid}
            onChange={(e) => { this.serviceAddressCheck(e, item) }} />
          <label htmlFor={i}>{item.service_address && item.service_address.address && item.service_address.address}</label>
        </div>
      )
    })
  }


  render() {
    let { is_edit_info, dog_info, is_update, loader, is_mobile, errors } = this.state;

    return (
      <div className="dog_service_wrapper">

        <div className="container">
          <div className="row">
            {this.renderDogList()}

            {/*             <div className="col-md-6 col-xl-4 col-lg-4"> */}
            {/*               <div className="blank_box"> */}
            {/*                 <div className="details"> */}
            {/*                   <h3> {dog_list.length > 0 ? 'Add Another Dog' : 'Create a Dog Profile'}</h3> */}
            {/*                   <p>{dog_list.length > 0 ? 'This will increase your quote' : 'Create a profile for each of your dogs so we can get to know them better on our visit.'}</p> */}
            {/*                   <button className="btn btn--secondary" onClick={() => { */}
            {/*                     let dog_info = { */}
            {/*                       can_clean_if_in_yard: false, */}
            {/*                       can_treat: false, */}
            {/*                       has_doggy_door: false, */}
            {/*                       is_friendly: false, */}
            {/*                     } */}
            {/*                     this.setState({ is_edit_info: true, is_update: false, dog_info }); */}
            {/*                   }}>Add Dog</button> */}
            {/*                 </div> */}
            {/*                 <img src={peeking_doodle} alt="" /> */}
            {/*               </div> */}
            {/*             </div> */}

          </div>
        </div>

        <Modal
          className="dog_details_pupup"
          visible={is_edit_info}
          footer={[
            <Button key="cancel" className="btn btn-outline--primary"
              onClick={() => { this.setState({ is_edit_info: false, dog_info: {}, is_dog_img: false, }) }}>Cancel</Button>,
            <Button key="submit" className="btn btn--secondary" onClick={(e) => {
              this.AddAndUpdateDog(e)
            }}>{is_update ? 'Update Dog' : 'Add Dog'}</Button>
          ]}>
          <div className="moday_body">
            <h4 className="modal_title">{is_update ? 'Edit dog' : 'Add dog '}</h4>
            <div className="img_upload">
              {dog_info.photo ?
                <div className="dog_profile_pic">
                  <img src={dog_info.photo} alt='' />
                  <span
                    onClick={() => {
                      let { dog_info } = this.state;
                      let temp_dog_info = { ...dog_info }
                      Object.assign(temp_dog_info, { 'photo': '' });
                      this.setState({
                        dog_info: temp_dog_info
                      })
                    }}
                    className="remove_images" ><img src={cross_icon} alt="" /></span>
                </div>
                :
                <div className="upload-btn-wrapper">
                  <button className="upload_btn"><img src={Upload_Photo} alt="" /></button>
                  <input type="file" onChange={(e) => { this.onDogImagesChange(e) }} />
                </div>
              }

              <div className="dog_details">
                <div className="billing_form">
                  <div className="billing_control sm-flex-col">
                    <div className="multi_control mr-2">
                      <input
                        type="text"
                        className="form--control"
                        name="name"
                        onChange={(e) => { this.onDogTextChange(e); }}
                        placeholder={is_mobile ? 'Name' : 'Dog Name'}
                        value={dog_info.name || ''} />
                    </div>
                    <div className="multi_control">
                      <input
                        type="text"
                        className="form--control"
                        name="breed"
                        onChange={(e) => { this.onDogTextChange(e); }}
                        placeholder="Breed" value={dog_info.breed || ''}
                      />
                    </div>
                  </div>                    
                  <div className="billing_control mb-0 hide-md">
                    <div className="single_control">
                      <div className={'flex pos-relative'}>
                        <input type={'text'} className="form--control" placeholder={'MM/DD/YYYY'}
                          maxLength={10} value={dog_info?.birthday || ''}
                          onChange={(e) => this.onBirthdayChange(e)}
                          onKeyDown={(e) => this.onBirthdayKeyPress(e)}/>
                        <div className={"only-icon-datepick"}>
                          <DatePicker
                            disabledDate={(current) => {
                              return current && current > moment().endOf("day");
                            }}                           
                            format="MM/DD/YYYY"
                            inputReadOnly
                            value={(dog_info.birthday && !isNaN(moment(dog_info.birthday, 'MM/DD/YYYY'))) ? moment(dog_info.birthday, 'MM/DD/YYYY') : null}
                            onChange={(e) => { this.onDogdateChange(e) }}
                            allowClear={false}
                            dropdownClassName="dog_date_dropdown"
                          />                          
                        </div>
                      </div>
                      {errors?.['birthday'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['birthday']}</label> : ''}
                    </div>
                  </div>                                          
                </div>                  
              </div>
            </div>
            <div className="billing_form show-md mt-3 ">
              <div className="billing_control mb-0">
                <div className="single_control">
                  <div className={'flex pos-relative'}>
                    <input type={'text'}  className="form--control" placeholder={'MM/DD/YYYY'}
                      maxLength={10} value={dog_info?.birthday || ''}
                      onChange={(e) => this.onBirthdayChange(e)}
                      onKeyDown={(e) => this.onBirthdayKeyPress(e)}/>
                    <div className={"only-icon-datepick"}>
                      <DatePicker
                        disabledDate={(current) => {
                          return current && current > moment().endOf("day");
                        }}
                        format="MM/DD/YYYY"
                        inputReadOnly
                        value={(dog_info.birthday && !isNaN(moment(dog_info.birthday, 'MM/DD/YYYY'))) ? moment(dog_info.birthday, 'MM/DD/YYYY') : null}
                        onChange={(e) => { this.onDogdateChange(e) }}
                        allowClear={false}
                        dropdownClassName="dog_date_dropdown"
                      />                      
                    </div>
                  </div>
                  {errors?.['birthday'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['birthday']}</label> : ''}
                </div>
              </div>
            </div> 
            <div className="billing_form ">
              <div className="billing_control">
                <textarea
                  className="form--control desc"
                  name="additional_info"
                  placeholder="Additional Information"
                  onChange={(e) => { this.onDogTextChange(e); }}
                  value={dog_info.additional_info ? dog_info.additional_info : ''}
                >
                </textarea>
              </div>
              <div className="border_line"></div>
            </div>

            <div className="basic_details">
              <div className="dog_safety">
                <label>Dog Information</label>
                <ul>
                  <li>
                    <div className="checkbox_wrapper green-check">
                      <input
                        type="checkbox"
                        name="is_friendly"
                        id="is_friendly"
                        checked={dog_info.is_friendly || false}
                        onChange={(e) => { this.onDogCheckChange(e) }}
                      />
                      <label htmlFor="is_friendly">Yes, my dog is friendly.</label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox_wrapper green-check">
                      <input
                        type="checkbox"
                        name="can_treat"
                        id="can_treat"
                        checked={dog_info.can_treat || false}
                        onChange={(e) => { this.onDogCheckChange(e) }}
                      />
                      <label htmlFor="can_treat">Yes, you can give my dog a treat.</label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox_wrapper green-check">
                      <input
                        type="checkbox"
                        name="can_clean_if_in_yard"
                        id="can_clean_if_in_yard"
                        checked={dog_info.can_clean_if_in_yard || false}
                        onChange={(e) => { this.onDogCheckChange(e) }}
                      />
                      <label htmlFor="can_clean_if_in_yard">Yes, you can clean with my dogs in the yard</label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox_wrapper green-check">
                      <input
                        type="checkbox"
                        name="has_doggy_door"
                        id="has_doggy_door"
                        checked={dog_info.has_doggy_door || false}
                        onChange={(e) => { this.onDogCheckChange(e) }}
                      />
                      <label htmlFor="has_doggy_door">Yes, there a doggy door</label>
                    </div>
                  </li>
                  <li>
                    <div className="checkbox_wrapper green-check">
                      <input
                        type="checkbox"
                        name="is_dogs_outside"
                        id="is_dogs_outside"
                        checked={dog_info.is_dogs_outside || false}
                        onChange={(e) => { this.onDogCheckChange(e) }}
                      />
                      <label htmlFor="is_dogs_outside">Yes, is left outside when no one is home</label>
                    </div>
                  </li>
                </ul>
              </div>
              {/* <div className="address">
                <label>Service Addresses</label>
                {this.renderServiceOrder()}

              </div> */}
            </div>
          </div>

        </Modal>



        {
          loader ?
            <div className='loader_wrapper'>
              <div className='loader07'></div>
            </div>
            : ''
        }
      </div >
    );
  }
}

export default Dogs;